import Axios from '../index'
import index from '../../../config/index'
// 获取器材库品牌分类
function getBrandClass ({}) {
  return Axios.get('/apis/depot/depotBrand?page=nopage', {
  })
}
// 获取器材库库品分类
function getEquipmentName ({}) {
  return Axios.get('/apis/depot/depotCategory/parent/0', {
  })
}
// 获取器材库列表
function getEquipmentList ({}) {
  return Axios.get('/apis/depot/depot?brand=&type=&key&category&order=goods_hits dec', {
  })
}
// 获取器材库详情
function getEquipmentDetails ({}) {
  return Axios.get('/apis/depot/depot/1', {
  })
}
// 获取相关帖子
function getAboutPosts ({}) { 
  return Axios.get('/app/topiclist.php?type=search_thread&fid=2&keyword=1&pageno=1&pagesize=20', {
  })
}
export {
  getBrandClass,
  getEquipmentName,
  getEquipmentList,
  getEquipmentDetails,
  getAboutPosts
}


// WEBPACK FOOTER //
// ./src/api/equipmentStoreHouse/axios.js